module.exports = __webpack_public_path__ + "img/logo.2d6aa4f2.png";